import { InfoPageStore } from '../info/InfoPageStore';

export class InfoStore {
  readonly pageStore: InfoPageStore;

  constructor(pageStore) {
    this.pageStore = pageStore;
    if (typeof window !== 'undefined') {
      (window as any).infoStore = this;
    }
  }

  get portalStore() {
    return this.pageStore.portalStore;
  }

  // @observable test = 1;
}
